import { useState } from 'react';
import { canDuplicateShift } from './duplicateShift';

const useTurniDragDrop = ({ handleDrop, handleDeleteTurno, handleUpdateFerieStatus, turniData = [] }) => {
  const [isDragOverTrash, setIsDragOverTrash] = useState(false);
  const [isDropTypeOpen, setIsDropTypeOpen] = useState(false);
  const [pendingDropData, setPendingDropData] = useState({ name: '', date: '' });
  const [pendingDuplicate, setPendingDuplicate] = useState(null);

  // Un badge turno rilasciato su un altro giorno chiede conferma di duplicazione
  const onShiftDrop = (e, dateStr) => {
    e.preventDefault();
    const shift = turniData.find(t => String(t.id) === e.dataTransfer.getData('shiftId'));
    if (canDuplicateShift(shift, dateStr)) setPendingDuplicate({ shift, targetDate: dateStr });
  };

  const onDrop = (e, dateStr) => {
    if (e.dataTransfer.getData('shiftId')) return onShiftDrop(e, dateStr);
    const droppedName = handleDrop(e, dateStr);
    if (droppedName) {
      setPendingDropData({ name: droppedName, date: dateStr });
      setIsDropTypeOpen(true);
    }
  };

  const closeDuplicate = () => setPendingDuplicate(null);

  const handleShiftDragStart = (e, shiftId) => e.dataTransfer.setData('shiftId', String(shiftId));
  const handleLeaveDragStart = (e, leaveId) => e.dataTransfer.setData('leaveId', String(leaveId));

  const handleTrashDrop = async (e) => {
    e.preventDefault();
    setIsDragOverTrash(false);
    const shiftId = e.dataTransfer.getData('shiftId');
    const leaveId = e.dataTransfer.getData('leaveId');
    if (shiftId) {
      try { await handleDeleteTurno(Number(shiftId)); } catch (_e) {}
    } else if (leaveId) {
      try { await handleUpdateFerieStatus(Number(leaveId), 'rifiutata'); } catch (_e) {}
    }
  };

  return {
    isDragOverTrash, setIsDragOverTrash,
    isDropTypeOpen, setIsDropTypeOpen,
    pendingDropData, onDrop,
    pendingDuplicate, closeDuplicate,
    handleShiftDragStart, handleLeaveDragStart, handleTrashDrop,
  };
};

export default useTurniDragDrop;
